module.exports = __webpack_public_path__ + "img/ln.866ed6ac.svg";